import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import ButtonWithLoader from "../../../../../common/components/ui/loading/ButtonLoading";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import {
  getBudgetMaintenancePDF,
  MaintenanceTemplateData,
} from "../../../../../common/services/maintenance.api";
import MaintenanceReport from "./MaintenanceReport";
import { IMaintenance } from "../../../../../types/maintenance.type";

type CreatePDFPropsBudgetMaintenance = {
  data: IMaintenance;
  formRequestErrors?: { message: string; path: string[] }[];
};

export function GeneratePdfBudgetMaintenance(
  props: CreatePDFPropsBudgetMaintenance
) {
  const { notifySuccess, notifyError } = useToastContext();
  const [createPDFBudgetMaintenance, setCreatePDFBudgetMaintenance] =
    useState(false);
  const [reportData, setReportData] = useState<MaintenanceTemplateData | null>(
    null
  );

  const reportRef = useRef(null);

  async function handleCreatePDFBudgetMaintenance() {
    try {
      setCreatePDFBudgetMaintenance(true);

      const maintenanceId = props.data._id;
      const response = await getBudgetMaintenancePDF(maintenanceId ?? "");
      const { data } = response;
      
      const result = data as unknown as MaintenanceTemplateData;   
      
      const dataTemplateHtml = {
        waitingTicket: result.waitingTicket,
        data_time: result.dataTime,
        mechanic: result.mechanic,
        type_of_review: result.typeOfReview,
        name: result.name,
        whatsapp: result.whatsapp,
        model: result.model,
        licensePlate: result.licensePlate,
        chassi: result.chassi,
        type_of_event: result.typeOfEvent,
        color: result.color,
        maintenanceItems: result.maintenanceItems,
        totalPreventivePrice: result.totalPreventivePrice,
        totalCorrectivePrice: result.totalCorrectivePrice,
        totalMisusePrice: result.totalMisusePrice,
        observations: result.observations,
        cobrancaTotal: result.cobrancaTotal,
      } as unknown as MaintenanceTemplateData;
      setReportData(dataTemplateHtml);

      notifySuccess("Dados do PDF gerados com sucesso!");
      handlePrint();
    } catch (err) {
      notifyError((err as Error).message);
    } finally {
      setCreatePDFBudgetMaintenance(false);
    }
  }

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
    documentTitle: "Maintenance Report",
    onAfterPrint: () => {
      notifySuccess("PDF gerado e enviado para impressão com sucesso!");
    },
  });

  const generateAndPrint = async () => {
    await handleCreatePDFBudgetMaintenance();
    setTimeout(handlePrint, 0); 
  };

  return (
    <div>
      <ButtonWithLoader
        type="button"
        isLoading={createPDFBudgetMaintenance}
        onClick={generateAndPrint}
      >
        Gerar folha de orçamento
      </ButtonWithLoader>

      {/* Elemento invisível para gerar o PDF */}
      <div style={{ display: "none" }}>
        <div ref={reportRef}>
          {reportData && (
            <MaintenanceReport
              waitingTicket={reportData.waitingTicket}
              data_time={reportData.dataTime}
              mechanic={reportData.mechanic}
              type_of_review={reportData.typeOfReview}
              name={reportData.name}
              whatsapp={reportData.whatsapp}
              model={reportData.model}
              licensePlate={reportData.licensePlate}
              chassi={reportData.chassi}
              type_of_event={reportData.typeOfEvent}
              color={reportData.color}
              maintenanceItems={reportData.maintenanceItems}
              totalPreventivePrice={reportData.totalPreventivePrice}
              totalCorrectivePrice={reportData.totalCorrectivePrice}
              totalMisusePrice={reportData.totalMisusePrice}
              observations={reportData.observations}
              cobrancaTotal={reportData.cobrancaTotal}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default GeneratePdfBudgetMaintenance;
